import FormItem from "@components/FormItem/FormItem";
import PortServiceUploadFiles from "@features/vessel-call/vessel-call-status/PortServices/form/PortServiceUploadFiles";
import { SHIP_TO_SHIP } from "@features/vessel-call/vessel-call-status/PortServices/form/utils";
import { type PortServicesOutletContext } from "@features/vessel-call/vessel-call-status/PortServices/PortServicesContainer";
import type { PortServicesFormData } from "@features/vessel-call/vessel-call-status/PortServices/schema/portServicesFormSchema";
import { endOfDay, startOfDay, subMonths } from "date-fns";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

const LANG_BASE = "vessel-call.port-services";

const ShipToShipUploadFields = () => {
  const { t } = useTranslation();
  const { updateFormData } = useOutletContext<PortServicesOutletContext>();
  const now = new Date();
  const maxSireReportIssueDate = endOfDay(now);
  const minSireReportIssueDate = startOfDay(subMonths(now, 6));

  return (
    <div className="flex flex-col gap-6" data-testid="ship-to-ship-upload-fields">
      <PortServiceUploadFiles
        title="sire-report"
        fileType={SHIP_TO_SHIP.DOCUMENT_TYPES.SIRE_REPORT}
        fieldName="sireReportDocuments"
        maxFiles={1}
        testId="sireReportDocuments-upload"
      >
        <div className="grid grid-cols-2">
          <FormItem<PortServicesFormData, "sireReportIssueDate">
            name="sireReportIssueDate"
            type="date-picker"
            label={t(`${LANG_BASE}.fields.sire-report-issue-date`)}
            testId="ship-to-ship-sire-report-issue-date"
            onFieldChange={updateFormData}
            minDate={minSireReportIssueDate}
            maxDate={maxSireReportIssueDate}
            timePicker
            combinedInput
          />
        </div>
      </PortServiceUploadFiles>

      <div className="flex flex-col gap-6">
        <PortServiceUploadFiles
          title="bill-of-lading"
          fileType={SHIP_TO_SHIP.DOCUMENT_TYPES.BILL_OF_LADING}
          fieldName="billOfLadingDocuments"
          maxFiles={10}
          testId="billOfLadingDocuments-upload"
        />
        <PortServiceUploadFiles
          title="cargo-manifest"
          fileType={SHIP_TO_SHIP.DOCUMENT_TYPES.CARGO_MANIFEST}
          fieldName="cargoManifestDocuments"
          maxFiles={10}
          testId="cargoManifestDocuments-upload"
        />
        <PortServiceUploadFiles
          title="certificate-of-origin"
          fileType={SHIP_TO_SHIP.DOCUMENT_TYPES.CERTIFICATE_OF_ORIGIN}
          fieldName="certificateOfOriginDocuments"
          maxFiles={10}
          testId="certificateOfOriginDocuments-upload"
        />
      </div>

      <PortServiceUploadFiles
        title="hose-certificate"
        fileType={SHIP_TO_SHIP.DOCUMENT_TYPES.HOSE_CERTIFICATE}
        fieldName="hoseCertificateDocuments"
        maxFiles={1}
        testId="hoseCertificateDocuments-upload"
      >
        <div className="grid grid-cols-2">
          <FormItem<PortServicesFormData, "hoseInspectionDate">
            name="hoseInspectionDate"
            type="date-picker"
            label={t(`${LANG_BASE}.fields.hose-inspection-date`)}
            testId="ship-to-ship-hose-inspection-date"
            onFieldChange={updateFormData}
            maxDate={maxSireReportIssueDate}
            timePicker
            combinedInput
          />
        </div>
      </PortServiceUploadFiles>
    </div>
  );
};

export default ShipToShipUploadFields;
